import { getLocaleFromNavigator } from "svelte-i18n";

export let getLocale = () =>
    window.localStorage.getItem("locale") ||
    getLocaleFromNavigator().split("-")[0] ||
    "de";